import { AttachMoneyOutlined } from "@mui/icons-material";
import { colors } from "../../../../theme/theme";
import { CustomInput, CustomTextArea } from "../../../Common/CustomInputs";
import CustomTagInput from "../../../Common/CustomTagInput";
import { Gapper } from "../../../ui/Gapper";
import AvatarSection from "./AvatarSection";
import { FormRow, SpecialtiesGrid } from "../practitionerForm.styles";
import * as C from "../practitionerForm.constants";
import { sanitizeHourlyRate } from "../practitionerForm.utils";
import { Box, useMediaQuery } from "@mui/material";

const ROW1_FIELDS = C.TAG_INPUT_FIELDS.slice(0, 3);
const ROW2_FIELDS = C.TAG_INPUT_FIELDS.slice(3, 6);

const BioAndSpecialtiesSection = ({
  submitData,
  updateField,
  avatarSectionProps,
  coverPictureSection,
}) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <Gapper gap={isMobile ? 0 : 15}>
      {coverPictureSection ? (
        <Box sx={{ display: "flex", flexDirection: "row", gap: isMobile ? 2 : 15 }}>
          <AvatarSection {...avatarSectionProps} />
          {coverPictureSection}
        </Box>
      ) : (
        <AvatarSection {...avatarSectionProps} />
      )}
      <CustomTextArea
        placeholder={C.PLACEHOLDER_BIO}
        label={C.LABEL_BIO}
        value={submitData.bio}
        setValue={(value) => updateField("bio", value)}
        width="100%"
        noIcon
      />
      <SpecialtiesGrid>
        <FormRow sx={{ mb: 0 }}>
          {ROW1_FIELDS.map(({ name, placeholder, label }) => (
            <CustomTagInput
              key={name}
              hashTags={submitData[name]}
              setHashTags={(value) => updateField(name, value)}
              color={colors.primary}
              placeholder={placeholder}
              label={label}
              validation
              validationMsg={C.TAG_VALIDATION_MSG}
            />
          ))}
        </FormRow>
        <FormRow sx={{ mb: 0 }}>
          {ROW2_FIELDS.map(({ name, placeholder, label }) => (
            <CustomTagInput
              key={name}
              hashTags={submitData[name]}
              setHashTags={(value) => updateField(name, value)}
              color={colors.primary}
              placeholder={placeholder}
              label={label}
              validation
              validationMsg={C.TAG_VALIDATION_MSG}
            />
          ))}
        </FormRow>
        <CustomInput
          value={submitData.hourlyRate}
          setValue={(value) =>
            updateField("hourlyRate", sanitizeHourlyRate(value))
          }
          placeholder={C.PLACEHOLDER_HOURLY_RATE}
          label={C.LABEL_HOURLY_RATE}
          smallBr
          bR="14px"
          width="100%"
          Icon={AttachMoneyOutlined}
          iconColor="green"
          type="String"
          color={colors.primary}
        />
      </SpecialtiesGrid>
    </Gapper>
  );
};

export default BioAndSpecialtiesSection;
